import { cn } from '@mntn/ui-components'
import type { HTMLAttributes } from 'react'

type CardDetailOverlayProps = HTMLAttributes<HTMLDivElement> & {
  overlayComponent: React.ReactNode
  backdropClassname?: string
}

/**
 * CardDetailOverlay is a component that displays an overlay on top of a card element.
 * The parent component must have the tailwind `group` class for hover state to work.

 * ```tsx
 * <CardDetailOverlay
 *   overlayComponent={<ProgramDetails />}
 * />
 * ```
 */
export const CardDetailOverlay = ({
  className,
  overlayComponent,
  backdropClassname,
  ...props
}: CardDetailOverlayProps) => {
  const backdropClass = cn('backdrop-blur-[6px] bg-alpha-sub-surface-bg-inverse', backdropClassname)
  return (
    <div className={cn('flex flex-col w-full transition-all duration-300 ease-in-out', className)} {...props}>
      <div className="flex flex-col">
        <div className={cn('flex justify-between items-center w-full p-4', backdropClass)}>{overlayComponent}</div>
      </div>
    </div>
  )
}
